import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Button } from "@mui/material";
import RejectReasonModal from "../../Modals/rejectReason";
import FreelancerRejectionReasonModal from "../../Modals/FreelancerRejectionReason";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import WorkHistoryList from "../../features/manageMaintenanceTeam/WorkHistoryList";
import {
  useLazyGetEmployerByIdQuery,
  useUpdateApproveStatusMutation,
  useUpdateApproveStatusFreelancerMutation,
  useUpdateEmployerMutation,
} from "../../services/users";

import { showError, showToast, showWarning } from "../../constants/toasts";
import useTranslation from "../../hooks/traslation";
import {
  APPROVED_STATUS,
  CERTIFICATE_TYPE,
  SECURITY_DOC_TYPE,
  SKILLS,
} from "../../utils/enums";
import { Employer } from "../../types/General";
import FreelancerPortfolio from "../../features/manageMaintenanceTeam/freelancerPortfolio";
import ViewDocModal from "../../Modals/viewDocModel";
import PdfPreviewModal from "../../Modals/pdfPreviewModal";
import { isValidInput } from "../../utils/validations";
import moment from "moment";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface Document {
  _id: string;
  link: string;
  type: number;
  docType: number;
}

interface FreelancerData {
  user: Employer;
  address: string;
  certificateDocs: Document[];
  securityDocs: Document[];
  profInfo: {
    industryExperience: string[];
    skills: number[];
    days: string[];
    _id: string;
    userId: string;
    startTime: string;
    endTime: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}

const MaintenanceTeamDetail = () => {
  const { id } = useParams();
  const translation = useTranslation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [updateAccountStatus] = useUpdateApproveStatusMutation();
  const [updateFreelancerStatus] = useUpdateApproveStatusFreelancerMutation();
  const [searchParams] = useSearchParams();
  const currentPage = searchParams.get("page") || "1";

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [getDataById] = useLazyGetEmployerByIdQuery();

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const [detail, setDetail] = useState<Employer | null>(null);
  const [doc, setDoc] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [rejectionRsn, setRejectionRsn] = useState("");
  const [openDocView, setOpenDocView] = useState(false);
  const [openRejection, setOpenRejection] = useState(false);
  const [data, setData] = useState<FreelancerData | null>(null);
  const [selectedDocUrl, setSelectedDocUrl] = useState("");
  const [updateEmployer] = useUpdateEmployerMutation();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [debouncedSearchTerm2, setDebouncedSearchTerm2] = useState<string>("");
  const [openPdfPreview, setOpenPdfPreview] = useState(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState("");

  const handleCloseModal = () => {
    setOpen(false);
  };

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getDataById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setDetail(response?.data?.user || null);
        setDoc(response?.data?.securityDocs || "");
        setData(response?.data);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleApprove = async (id: string) => {
    try {
      const response = await updateAccountStatus({
        id,
        body: { approveStatus: APPROVED_STATUS.APPROVED },
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast("Freelancer approved successfully");
        const currentTab =
          searchParams.get("tab") ||
          (detail?.approveStatus ? detail?.approveStatus - 1 : "0");
        navigate(`/manage-freelancer?tab=${currentTab}&page=${currentPage}`);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleApproveReject = async (id: string, approveStatus: number) => {
    if (approveStatus === APPROVED_STATUS.REJECTED) {
      setOpenRejection(true);
      return;
    }

    if (approveStatus === APPROVED_STATUS.APPROVED) {
      handleApprove(id);
      return;
    }
  };

  const handleReject = async (
    id: string,
    approveStatus: number,
    reason: string
  ) => {
    if (!reason) {
      showWarning("Please add rejection reason");
      return;
    }

    const body = {
      approveStatus,
      rejectReason: reason,
    };

    try {
      const response = await updateFreelancerStatus({ id, body }).unwrap();
      if (response?.statusCode === 200) {
        setRejectionRsn("");
        setOpenRejection(false);
        showToast("Freelancer rejected successfully");
        const currentTab =
          searchParams.get("tab") ||
          (detail?.approveStatus ? detail?.approveStatus - 1 : "0");
        navigate(`/manage-freelancer?tab=${currentTab}&page=${currentPage}`);
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1>{translation.main.manageFreelancer}</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>
              {translation.dashboard.dashboard}
            </span>{" "}
            -{" "}
            <span
              onClick={() =>
                navigate(
                  `/manage-freelancer?tab=${
                    detail?.approveStatus ? detail?.approveStatus - 1 : "0"
                  }&page=${currentPage}`
                )
              }
            >
              {translation.main.manageFreelancer}
            </span>{" "}
            - {translation.main.freelancerDetail}
          </p>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label={translation.main.generalDetail} {...a11yProps(0)} />
                <Tab
                  label={translation.main.freeLancerPortfolio}
                  {...a11yProps(1)}
                />
                <Tab label={translation.main.workHistory} {...a11yProps(2)} />
              </Tabs>
            </Box>
          </div>
        </div>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>{translation.main.personalDetail}</h2>
            </div>
            <div className="gap_p">
              <div className="vew_img w_100">
                <h6>{translation.main.Image}</h6>
                <figure>
                  <img
                    alt="user"
                    src={detail?.image || "/static/images/user_placeholder.png"}
                  />
                </figure>
              </div>
              <div className="w_33">
                <h6>{translation.globals.name}</h6>
                <p>
                  {detail?.firstName || ""} {detail?.lastName || ""}
                </p>
              </div>
              <div className="w_33">
                <h6>{translation.main.email}</h6>
                <p>{detail?.email || ""}</p>
              </div>
              <div className="w_33">
                <h6>{translation.main.phone}</h6>
                <p>
                  {detail?.dialCode || ""} {detail?.phoneNo || ""}
                </p>
              </div>
              {/* <div className="w_33">
                <h6>Address</h6>
                <p>{detail?.address?.addressName || ""} </p>
              </div> */}
            </div>
          </div>

          <div className="cards view_page">
            <div className="section_title">
              <h2>{translation.main.Skills}</h2>
            </div>
            <div className="gap_p">
              <div className="w_33">
                <h6>
                  {data?.profInfo?.skills
                    ?.map((skillId: number) => {
                      return SKILLS[skillId] || "";
                    })
                    .filter(Boolean)
                    .join(", ") || "No skills listed"}
                </h6>
              </div>
            </div>
          </div>

          <div className="cards view_page">
            <div className="section_title">
              <h2>Availability</h2>
            </div>
            <div className="gap_p">
              <div className="w_50">
                <h6>Working Days</h6>
                <p>
                  {data?.profInfo?.days
                    ?.map(
                      (day: string) =>
                        day.charAt(0).toUpperCase() + day.slice(1)
                    )
                    .join(", ") || "No working days specified"}
                </p>
              </div>
              <div className="w_50">
                <h6>Working Hours</h6>
                <p>
                  {data?.profInfo?.startTime && data?.profInfo?.endTime
                    ? `${moment(data.profInfo.startTime).format(
                        "hh:mm A"
                      )} - ${moment(data.profInfo.endTime).format("hh:mm A")}`
                    : "No working hours specified"}
                </p>
              </div>
            </div>
          </div>
          <div className="cards view_page">
            <div className="section_title">
              <h2>{translation.main.Documents}</h2>
            </div>
            <div className="gap_p">
              {/* Security Documents */}
              {data?.securityDocs && data.securityDocs.length > 0 ? (
                <div className="document_section">
                  <h3>Security Documents</h3>
                  <div className="gap_p">
                    {data.securityDocs.map((doc: Document) => {
                      const isPdf = doc?.link?.toLowerCase().endsWith(".pdf");
                      const isImage = doc?.link
                        ?.toLowerCase()
                        .match(/\.(jpg|jpeg|png|gif|bmp|webp)$/);
                      const docType =
                        doc.docType === SECURITY_DOC_TYPE.CIVIL_ID
                          ? "Civil ID"
                          : "Driving License";

                      return (
                        <div className="w_33" key={doc._id}>
                          <h6>{docType}</h6>
                          {isImage && (
                            <figure
                              className="passport_img"
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                width: "100%",
                                height: "200px",
                                margin: 0,
                                padding: 0,
                                overflow: "hidden",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                              }}
                              onClick={() => {
                                setSelectedDocUrl(doc?.link);
                                setOpenDocView(true);
                              }}
                            >
                              <img
                                src={
                                  doc?.link || "/static/images/placeholder.png"
                                }
                                alt={docType}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </figure>
                          )}
                          {isPdf && (
                            <figure
                              className="passport_img"
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                width: "100%",
                                height: "200px",
                                margin: 0,
                                padding: 0,
                                overflow: "hidden",
                              }}
                              onClick={() => {
                                setSelectedPdfUrl(doc?.link);
                                setOpenPdfPreview(true);
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f5f5f5",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                }}
                              >
                                <div style={{ textAlign: "center" }}>
                                  <img
                                    src="/static/images/pdf.png"
                                    alt="PDF Icon"
                                    style={{
                                      width: "60px",
                                      height: "60px",
                                      marginBottom: "12px",
                                    }}
                                  />
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      color: "black",
                                    }}
                                  >
                                    Click to preview PDF
                                  </p>
                                </div>
                              </div>
                            </figure>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="document_section">
                  <h3>Security Documents</h3>
                  <div className="gap_p">
                    <p>No security documents available</p>
                  </div>
                </div>
              )}
              {/* Certificate Documents */}
              <div className="document_section">
                <h3>Certificate Documents</h3>
                {data?.certificateDocs && data.certificateDocs.length > 0 ? (
                  <div className="gap_p">
                    {data.certificateDocs.map((doc: Document) => {
                      const isPdf = doc?.link?.toLowerCase().endsWith(".pdf");
                      const isImage = doc?.link
                        ?.toLowerCase()
                        .match(/\.(jpg|jpeg|png|gif|bmp|webp)$/);
                      const docType =
                        doc.docType === CERTIFICATE_TYPE.EDUCATION
                          ? "Education Certificate"
                          : "Training Certificate";

                      return (
                        <div className="w_33" key={doc._id}>
                          <h6>{docType}</h6>
                          {isImage && (
                            <figure
                              className="passport_img"
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                width: "100%",
                                height: "200px",
                                margin: 0,
                                padding: 0,
                                overflow: "hidden",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                              }}
                              onClick={() => {
                                setSelectedDocUrl(doc?.link);
                                setOpenDocView(true);
                              }}
                            >
                              <img
                                src={
                                  doc?.link || "/static/images/placeholder.png"
                                }
                                alt={docType}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </figure>
                          )}
                          {isPdf && (
                            <figure
                              className="passport_img"
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                width: "100%",
                                height: "200px",
                                margin: 0,
                                padding: 0,
                                overflow: "hidden",
                              }}
                              onClick={() => {
                                setSelectedPdfUrl(doc?.link);
                                setOpenPdfPreview(true);
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f5f5f5",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                }}
                              >
                                <div style={{ textAlign: "center" }}>
                                  <img
                                    src="/static/images/pdf.png"
                                    alt="PDF Icon"
                                    style={{
                                      width: "60px",
                                      height: "60px",
                                      marginBottom: "12px",
                                    }}
                                  />
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      color: "black",
                                    }}
                                  >
                                    Click to preview PDF
                                  </p>
                                </div>
                              </div>
                            </figure>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="gap_p">
                    <p>No certificate documents available</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="cards view_page">
            {detail?.approveStatus === APPROVED_STATUS.REJECTED &&
              detail?.rejectReason && (
                <div className="section_title">
                  <h2>{translation.main.rejectionReason}</h2>
                  <div className="gap_p">
                    <div className="w_100">
                      <p style={{ marginTop: "15px" }}>
                        {detail?.rejectReason}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            <div className="form_btn">
              {detail?.approveStatus !== APPROVED_STATUS.APPROVED && (
                <Button
                  className="btn btn_primary"
                  onClick={() =>
                    handleApproveReject(
                      detail?._id || "",
                      APPROVED_STATUS.APPROVED
                    )
                  }
                >
                  {translation.main.Approve}
                </Button>
              )}
              {detail?.approveStatus !== APPROVED_STATUS.REJECTED &&
                detail?.approveStatus !== APPROVED_STATUS.APPROVED && (
                  <Button
                    className="btn btn_danger"
                    onClick={() =>
                      handleApproveReject(
                        detail?._id || "",
                        APPROVED_STATUS.REJECTED
                      )
                    }
                  >
                    {translation.main.Reject}
                  </Button>
                )}
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards">
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    placeholder={translation.user.SearchHere}
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setDebouncedSearchTerm}
                    value={searchTerm}
                    onCross={() => setSearchTerm("")}
                    onChange={(val: any) => {
                      if (isValidInput(val.target.value)) {
                        setSearchTerm(val.target.value);
                      }
                    }}
                  />
                </Box>
              </div>
            </div>

            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <FreelancerPortfolio
                freelancerId={id || ""}
                // setDebouncedSearchTerm={setDebouncedSearchTerm}
                debouncedSearchTerm={debouncedSearchTerm}
              />
            </Box>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="cards">
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    placeholder={translation.user.SearchHere}
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setDebouncedSearchTerm2}
                    value={searchTerm}
                    onCross={() => setSearchTerm("")}
                    onChange={(val: any) => {
                      if (isValidInput(val.target.value)) {
                        setSearchTerm(val.target.value);
                      }
                    }}
                  />
                </Box>
              </div>
            </div>

            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <WorkHistoryList
                freelancerId={id || ""}
                debouncedSearchTerm={debouncedSearchTerm2}
              />
            </Box>
          </div>
        </CustomTabPanel>
      </MainContainer>

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
      <FreelancerRejectionReasonModal
        open={openRejection}
        onClose={handleReject}
        setOpen={setOpenRejection}
        selectedId={detail?._id || ""}
        setRejectionRsn={setRejectionRsn}
        rejectionRsn={rejectionRsn}
      />
      <ViewDocModal
        open={openDocView}
        onClose={() => setOpenDocView(false)}
        imageUrl={selectedDocUrl}
      />
      <PdfPreviewModal
        open={openPdfPreview}
        onClose={() => setOpenPdfPreview(false)}
        pdfUrl={selectedPdfUrl}
      />
    </>
  );
};

export default MaintenanceTeamDetail;
